/** @jsx jsx */
/* eslint-disable no-use-before-define */
import {jsx, css} from '@emotion/core'
import React from 'react'
import { useOrderTicket, MODES } from '../use-order-ticket.js'
import { CusipSearch } from './cusip-search/cusip-search.js'
import { SelectHolding } from './select-holding.js'
import { mediaQueries, arrayFrom, show, } from '../../twd'
export const SelectCusip = () => {

    const { cusip,
        acctNo,
        mode, errors,
        setCusip,
        positions,
        actionSubset_,
    } = useOrderTicket()

    const canEdit = mode !== MODES.ORDER_Z

    const updateCusip = (newCusip) => {
        if (!newCusip) return
        newCusip = newCusip.toUpperCase().trim()

        if (cusip && cusip===newCusip) return

        const hasCusip = arrayFrom(positions).map(({cusip}) => cusip).indexOf(newCusip)>=0

        const isRqt = mode === MODES.RFQ
        const act = isRqt ? 'W'
            : !isRqt && hasCusip ? 'S'
            : 'B'

        const isBuySell = act==='B' || act==='S'

        setCusip(newCusip)

        setTimeout(() => {
            show('order-ticket', {
                acctNo,
                cusip: newCusip,
                action: act,
                actionSubset: isBuySell ? '' : actionSubset_,
                ts: Date.now(),
            })
        }, 200)
    }

    return <React.Fragment>
        <div className="row">
        <div className="col-md-6 col-xs-12 vertical-offset-xs" css={selectCusipCss}>
            <CusipSearch
                acctNo={acctNo}
                cusip={cusip}
                setCusip={updateCusip}
                readOnly={!canEdit}
                errors={errors}
                isQrt={actionSubset_==='WF'}
                />
        </div>

        {canEdit && <div className="text-center" css={orCss}>or</div>}

        {canEdit && <React.Fragment>
            <div className="col-md-6 col-xs-12 vertical-offset-xs" css={selectHoldingCss}>
            <SelectHolding />
            </div>
        </React.Fragment>
        }
        </div>
    </React.Fragment>
}

const selectCusipCss = css`
    ${mediaQueries.notXs} {
        float: left;
        width: calc(50% - 10px);
        padding-right: 0px;
    }
`

const orCss = css`
    font-weight: 500;
    ${mediaQueries.notXs} {
        display: inline-block;
        max-width: 20px;
        margin-top: 20px;
        margin-left: 5px;
    }
    ${mediaQueries.xs} {
        margin-bottom:15px;
    }
`


const selectHoldingCss = css`
    ${mediaQueries.notXs} {
        float: right;
        padding-left: 0px;
        width: calc(50% - 10px);
    }
`



// WEBPACK FOOTER //
// ./src/order-ticket/form/select-cusip.js